import { openBlock as l, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, e) {
  return l(), t("svg", n, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M12 2a2.5 2.5 0 0 1 2.49 2.307c2.355 1.002 4.012 3.382 4.012 6.159v6.132l1.007.826c.93.762.45 2.276-.7 2.37l-.113.005h-3.468a3.252 3.252 0 0 1-6.454 0h-3.47l-.113-.005c-1.112-.09-1.598-1.511-.786-2.294l.085-.076 1.006-.826v-6.132c0-2.777 1.657-5.158 4.013-6.16A2.5 2.5 0 0 1 12 2m-1.91 17.799a1.952 1.952 0 0 0 3.823 0zm1.91-15c-3.015 0-5.503 2.514-5.503 5.667v6.605l-.365.3-1.006.825a.33.33 0 0 0-.102.386.35.35 0 0 0 .11.164.26.26 0 0 0 .17.053h13.393a.26.26 0 0 0 .17-.053.35.35 0 0 0 .112-.164.33.33 0 0 0-.103-.386l-1.007-.825-.366-.3v-6.605c0-3.055-2.334-5.51-5.222-5.66zM12 3a1.5 1.5 0 0 0-1.396.954 6.4 6.4 0 0 1 2.792 0A1.5 1.5 0 0 0 12 3"
    }, null, -1)
  ])]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
